/**
 *  hide
 **/
(function () {
  "use strict";
  function attachHideEvent(el) {
    const main = el.querySelectorAll(".hide-content");
    let title = el.title;
    if (el.body) {
      title += el.body.className;
    } else {
      const htmlText = el.textContent.replace(/\s+/g, "");
      title = document.createTextNode(htmlText);
    }

    (async () => {
      // ID 作成処理
      let unique_id = await sha256(title);
      main.forEach((element, key) => {
        let id = "hide-" + unique_id + "-" + key;
        let btn_id = "hide-" + unique_id + "-" + key + "-btn";
        let target_id = "#hide-" + unique_id + "-" + key;
        let content_id = "hide-" + unique_id + "-" + key + "-icon";

        // element
        let anchor = element.querySelector("a.btn-hide");
        let anchor_i = anchor.querySelector("i");
        let this_collapse = element.querySelector(".hide-collapse");

        if (this_collapse) {
          this_collapse.id = id;
        }
        if (anchor) {
          anchor.id = btn_id;
          anchor.setAttribute("data-target", target_id);
        }
        if (anchor_i) {
          anchor_i.id = content_id;
        }
      });

      // hideの開閉状態を記憶
      let hide_content = el.querySelectorAll(".hide-content .collapse");
      let hide_collapse = el.querySelectorAll(".hide-collapse");

      hide_content.forEach((element) => {
        // Bootstrapがjqeuryのため開閉イベント取得はjqeury
        $(element).on("show.bs.collapse", function () {
          var max_size = 20;
          var active = this.id;
          var panels =
            localStorage.panels === undefined
              ? []
              : JSON.parse(localStorage.panels);
          if (!panels.includes(active)) {
            panels.push(active);
            if (panels.length > max_size) {
              panels = panels.slice(panels.length - max_size);
            }
          }
          localStorage.panels = JSON.stringify(panels);
        });

        // 展開完了時、内部の lazy 画像を再評価する。
        // 閉じている間は IntersectionObserver が再評価できないため、
        // 開いた瞬間に再 observe して即座にロードを発火させる。
        // また、 lazy 画像も gallery に事前登録するため scan() を再実行する。
        $(element).on("shown.bs.collapse", function () {
          if (window.MokoImagePopup) {
            if (typeof window.MokoImagePopup.scan === "function") {
              window.MokoImagePopup.scan(this);
            }
            if (typeof window.MokoImagePopup.lazyRefresh === "function") {
              window.MokoImagePopup.lazyRefresh(this);
            }
          }
        });
      });

      hide_collapse.forEach((element) => {
        // Bootstrapがjqeuryのため開閉イベント取得はjqeury
        $(element).on("hide.bs.collapse", function () {
          var active = this.id;
          var panels =
            localStorage.panels === undefined
              ? []
              : JSON.parse(localStorage.panels);
          var elementIndex = panels.indexOf(active);
          if (elementIndex !== -1) {
            panels.splice(elementIndex, 1);
          }
          localStorage.panels = JSON.stringify(panels);
        });
      });

      try {
        var panels =
          localStorage.panels === undefined
            ? []
            : JSON.parse(localStorage.panels);

        for (var i in panels) {
          let panel = el.querySelector("#" + panels[i]);
          if (panel && panel.classList.contains("hide-collapse")) {
            let btn = el.querySelector("#" + panels[i] + "-btn");
            if (!panel.classList.contains("in")) {
              //開く
              $(panel).collapse("show");
              //開くボタンの見た目を変える
              btn.classList.remove("collapsed");
            }
          }
        }
      } catch (error) {
        console.error(error);
      }
    })();
  }

  document.addEventListener("DOMContentLoaded", function () {
    attachHideEvent(document);
  });

  document.addEventListener("customDOMContentLoaded", function (event) {
    const modalWindow = event.detail.modalWindow;
    attachHideEvent(modalWindow);
  });

  async function sha256(str) {
    // attachHideEvent 側で title が Text node になる経路があるため、
    // ハッシュ関数の入口で必ず String 化しておく (charCodeAt 呼び出しの安全性確保)。
    const input = typeof str === "string" ? str : String(str ?? "");
    // SubtleCrypto は HTTPS / localhost などの Secure Context でしか使えない。
    // Secure でない場合 (ローカル http 開発環境など) は FNV-1a 32bit のフォールバック
    // を用いる。ID 衝突回避が目的であり暗号強度は不要。
    if (
      typeof crypto !== "undefined" &&
      crypto.subtle &&
      typeof crypto.subtle.digest === "function"
    ) {
      try {
        const encoder = new TextEncoder();
        const buff = encoder.encode(input);
        const digest = await crypto.subtle.digest("SHA-256", buff);
        return [].map
          .call(new Uint8Array(digest), (x) => ("00" + x.toString(16)).slice(-2))
          .join("");
      } catch (e) {
        // 続行してフォールバック
      }
    }
    return fnv1aHex(input);
  }

  // FNV-1a 32bit ハッシュ (フォールバック用)。Secure Context でない環境向け。
  function fnv1aHex(str) {
    const s = typeof str === "string" ? str : String(str ?? "");
    let h = 0x811c9dc5; // FNV offset basis
    for (let i = 0; i < s.length; i++) {
      h ^= s.charCodeAt(i);
      h = Math.imul(h, 0x01000193) >>> 0; // FNV prime
    }
    return ("00000000" + h.toString(16)).slice(-8);
  }
})();
